import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import rod from "../../Asset/rod.jpg";
import roof from "../../Asset/Roofing Sheets.jpg";
import cement from "../../Asset/jsw-cement-1.jpg";
import paint from "../../Asset/Pixa Joie Classic Interiors.png";
import steel from "../../Asset/Structural-steel.jpg";

import { GiPlainSquare } from "react-icons/gi";
import { Link } from "react-router-dom";

// Product Data
const productData = [
  { image: rod, title: "TMT Steel" },
  { image: steel, title: "Structural  Steel" },
  { image: roof, title: "Roofing Sheets" },
  { image: cement, title: "Cement" },
  { image: paint, title: "Paint" },
];

const Products = () => {
  return (
    <div className="max-w-screen-2xl mx-auto px-4 py-16 flex flex-col md:flex-row gap-10  ">
      {/* Left - Swiper */}
      <div className="w-full md:w-1/2">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          loop={true}
          autoplay={{ delay: 3000 }}
          pagination={{ clickable: true }}
          className="w-full h-full"
        >
          {productData.map((product, index) => (
            <SwiperSlide key={index}>
              <div className="flex flex-col items-center justify-center h-[400px]">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-[280px] object-contain rounded-md"
                />
                <p className="mt-4 text-xl font-semibold text-[#114497]">
                  {product.title}
                </p>
                
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div> 

      {/* Right - Content */}
      <div className="w-full md:w-1/2 space-y-6 flex flex-col justify-center text-center md:text-left">
        <h2 className="text-4xl sm:text-5xl font-bold text-[#114497] leading-tight">
          Our Products
        </h2>
        <p className="text-gray-700 text-base">
          Sai Steel bars, ranging in size from 8mm to 40mm, are available in
          grades including Fe 500, Fe 500D, Fe 550,   Fe 550D   and  550D CRS  — all with a standard
          length of 12m. We also offer Roofing Sheets, Cement, and Premium Paint
          solutions tailored to your construction needs.
        </p>
        <Link to ="/products">
        <button className="bg-[#fbb613] text-white py-2 px-6  hover:bg-[#114497] transition duration-300 w-fit mx-auto md:mx-0">
          View More
        </button>
         </Link>  
      </div>
    </div>
  );
};

export default Products;
